import Swiper, { Autoplay, Pagination, Navigation } from 'swiper';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import { CountUp } from 'countup.js';
import { Modal } from 'bootstrap';
import PDFjs from 'pdfjs-dist';

function init3QVideo(video) {
   const config = JSON.parse(decodeURI(video.dataset.threeq))
   const playerId = 'video-3q-' + Date.now()

   video.setAttribute('id', playerId)

   new js3q({
      dataid: config.playoutId,
      container: playerId,
      cast: false,
      key: config.playoutKey,
      timestamp: Date.now()
  })

  video.classList.add('video-3q--initialized')
}

function initNew3QVideos() {
   const videos = document.querySelectorAll('[data-threeq]:not(.video-3q--initialized)')

   videos.forEach(newVideo => {
      init3QVideo(newVideo)
   })
}

// Mobile Height Hack
function mobileHeight() {
   let vh = window.innerHeight * 0.01;
   document.documentElement.style.setProperty('--vh', `${vh}px`);
}

mobileHeight();

// Masonry Download Grid
function initMasonryDownload() {
   const gridDownload = document.querySelector('.grid-download:not(.grid-download--initialized)');

   if (gridDownload) {
      imagesLoaded(gridDownload, function () {
         // init Isotope after all images have loaded
         new Masonry(gridDownload, {
            itemSelector: '.grid-download-item',
            columnWidth: '.grid-download-sizer',
            transitionDuration: 0,
            percentPosition: true
         })

         gridDownload.classList.add('grid-download--initialized')
      })
   }
}

initMasonryDownload()


function initSwiperInstances() {
   // Swiper Gallery
   const swiperGallery = new Swiper(".swiper-gallery", {
      modules: [Autoplay, Pagination, Navigation],
      spaceBetween: 30,
      autoHeight: true,
      loop: true,
      allowTouchMove: true,
      slidesPerView: "auto",
      centeredSlides: true,

      pagination: {
         el: ".swiper-teaser-pagination",
         clickable: true,
      },
      navigation: {
         nextEl: '.swiper-teaser-next',
         prevEl: '.swiper-teaser-prev',
      },
      keyboard: {
         enabled: true,
         onlyInViewport: true,
      },
      a11y: {
         prevSlideMessage: 'Einen Slide zurück',
         nextSlideMessage: 'Einen Slide vor',
      }
   })

   // Swiper Teaser Big
   const swiperTeaserBig = new Swiper(".swiper-teaser-big", {
      modules: [Autoplay, Pagination, Navigation],
      slidesPerView: 1,
      spaceBetween: 30,
      // autoHeight: true,
      loop: true,
      allowTouchMove: true,

      breakpoints: {
         768: {
            slidesPerView: 2
         }
      },
      pagination: {
         el: ".swiper-teaser-pagination",
         clickable: true,
      },
      navigation: {
         nextEl: '.swiper-teaser-next',
         prevEl: '.swiper-teaser-prev',
      },
   })

   // Swiper Teaser Highlight
   const swiperTeaserHighlight = new Swiper(".swiper-teaser-highlight", {
      modules: [Autoplay, Pagination, Navigation],
      slidesPerView: 1,
      spaceBetween: 30,
      autoHeight: true,
      loop: true,
      allowTouchMove: true,

      pagination: {
         el: ".swiper-teaser-pagination",
         clickable: true,
      },
      navigation: {
         nextEl: '.swiper-teaser-next',
         prevEl: '.swiper-teaser-prev',
      },
   })

   // Swiper Teaser Header
   const swiperTeaserHeader = new Swiper(".swiper-teaser-header", {
      modules: [Autoplay, Pagination, Navigation],
      slidesPerView: 1,
      spaceBetween: 30,
      autoHeight: true,
      loop: true,
      allowTouchMove: true,
      autoplay: {
         delay: 7500,
      },
      pagination: {
         el: ".swiper-teaser-header-pagination",
         clickable: true,
      },
      navigation: {
         nextEl: '.swiper-teaser-header-next',
         prevEl: '.swiper-teaser-header-prev',
      },
   })

   // Swiper Teaser Content
   const swiperContent = new Swiper(".swiper-content", {
      modules: [Autoplay, Pagination, Navigation],
      slidesPerView: 1,
      spaceBetween: 30,
      autoHeight: true,
      loop: true,
      allowTouchMove: true,

      pagination: {
         el: ".swiper-teaser-pagination",
         clickable: true,
      },
      navigation: {
         nextEl: '.swiper-teaser-next',
         prevEl: '.swiper-teaser-prev',
      },
   })

   // Swiper Teaser Big
   const swiperNewsticker = new Swiper(".swiper-newsticker", {
      modules: [Autoplay, Pagination, Navigation],
      slidesPerView: 1,
      spaceBetween: 30,
      // autoHeight: true,
      loop: false,
      allowTouchMove: true,

      breakpoints: {
         768: {
            slidesPerView: 2
         },
         992: {
            slidesPerView: 3
         }
      },
      pagination: {
         el: ".swiper-teaser-pagination",
         clickable: true,
      },
      navigation: {
         nextEl: '.swiper-teaser-next',
         prevEl: '.swiper-teaser-prev',
      },
   })
}

initSwiperInstances()

// ScrollToTop
const scrollToTop = document.querySelector('.side-totop');

if (scrollToTop) {
   scrollToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
   })

   window.onscroll = function () { scrollFunction() };

   function scrollFunction() {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
         scrollToTop.classList.add('show');
      } else {
         scrollToTop.classList.remove('show');
      }
   }
}


// Countupjs Teaser Number
function initCountUp() {
   const counterTeaserNumbers = document.querySelectorAll(".teaser-number:not(.teaser-number--initialized)");

   if (counterTeaserNumbers) {
      counterTeaserNumbers.forEach(function (counterTeaserNumber) {
         const counterTeaserNumberItem = counterTeaserNumber.querySelector(".teaser-number__number");
         const counterTeaserNumberData = counterTeaserNumberItem.dataset.number;
         const counterTeaserNumberDataDecimal = counterTeaserNumberItem.dataset.mode;
         
         const observeOptions = {
            root: null,
            threshold: 0.75,
         };

         if (counterTeaserNumberDataDecimal === "decimal") {
            const counterTeaserNumberOptionDecimal = {
               decimalPlaces: counterTeaserNumberItem.dataset.decimals ? counterTeaserNumberItem.dataset.decimals : 2,
               decimal: ',',
               separator: ".",
               duration: 2.5,
            };

            let countUpDezimal = new CountUp(counterTeaserNumberItem, counterTeaserNumberData, counterTeaserNumberOptionDecimal);

            const observerTeaserNumberDecimal = new IntersectionObserver(function (entries, observer) {
               entries.forEach((entry) => {
                  if (!entry.isIntersecting) {
                     return;
                  } else {
                     countUpDezimal.start();
                     observerTeaserNumberDecimal.unobserve(entry.target);
                  }
               });
            }, observeOptions);

            observerTeaserNumberDecimal.observe(counterTeaserNumber);
         } else {
            const counterTeaserNumberOption = {
               separator: ".",
               duration: 2.5,
            };

            const countUp = new CountUp(counterTeaserNumberItem, counterTeaserNumberData, counterTeaserNumberOption);

            const observerTeaserNumber = new IntersectionObserver(function (entries, observer) {
               entries.forEach((entry) => {
                  if (!entry.isIntersecting) {
                     return;
                  } else {
                     countUp.start();
                     observerTeaserNumber.unobserve(entry.target);
                  }
               });
            }, observeOptions);

            observerTeaserNumber.observe(counterTeaserNumber);
         }

         counterTeaserNumber.classList.add('teaser-number--initialized');
      });
   }
}

initCountUp()

// Navigation Mobile

const navToggle = document.getElementById("navToggle");
const navigation = document.getElementById("navigation");
const navOverlay = document.getElementById("navOverlay");
const body = document.body;

function openNavigation() {
   body.classList.add('overflow');
   navToggle.classList.add('navheader__toggle--active');
   navToggle.setAttribute('aria-expanded', 'true');
   navigation.classList.add('navigation--active');
   navOverlay.classList.add('navigation-overlay--active');
}

function closeNavigation() {
   body.classList.remove('overflow');
   navToggle.classList.remove('navheader__toggle--active');
   navToggle.setAttribute('aria-expanded', 'false');
   navigation.classList.remove('navigation--active');
   navOverlay.classList.remove('navigation-overlay--active');
}

navToggle.addEventListener('click', () => {
   if (navigation.classList.contains('navigation--active')) {
      closeNavigation();
   } else {
      openNavigation();
   }
});

navOverlay.addEventListener('click', () => {
   closeNavigation();
});

const navSublists = document.querySelectorAll('.navigation__sublist');

navSublists.forEach(function (navSublist) {
   const navMore = navSublist.parentNode.children[1];
   const navSublistParent = navSublist.parentNode;

   navMore.addEventListener('click', () => {
      if (navSublistParent.classList.contains('navigation__item--active')) {
         navSublistParent.classList.toggle('navigation__item--toggle-active');
      } else {
         navSublistParent.classList.toggle('navigation__item--toggle');
      };
   });
});

const navHeader = document.querySelector(".navheader");

if (navHeader) {
   window.onscroll = () => scrollNavigation();

   function scrollNavigation() {
      if (document.body.scrollTop > 140 || document.documentElement.scrollTop > 140) {
         navHeader.classList.add('navheader--scroll');
      } else {
         navHeader.classList.remove('navheader--scroll');
      }
   }
}

function initLoadMoreBtn(button, url = '?', success = () => { }, fail = () => { }) {
   button.addEventListener('click', () => {
      if (!button.classList.contains('btn-loader--spinning')) {
         button.classList.add('btn-loader--spinning')
         const page = parseInt(button.dataset.page)

         fetch(url + 'page=' + page, {
            headers: {
               'X-Requested-With': 'XMLHttpRequest'
            }
         })
            .then(response => {
               if (response.status >= 200 && response.status < 400) {
                  return response.json()
               }

               return response.json()
                  .then(json => Promise.reject(json))
            })
            .then(response => {
               button.dataset.page = page + 1

               success(response)
            })
            .catch(error => {
               fail(error)
            })
            .finally(() => {
               button.classList.remove('btn-loader--spinning')
            })
      }
   })
}

// More Article Button

const btnMoreArticles = document.querySelectorAll('.btn-more-articles')

if (btnMoreArticles) {
   const url = location.search.length ? location.search + '&' : '?'

   btnMoreArticles.forEach(button => {
      initLoadMoreBtn(button, url,
         response => {
            const articleTeasers = document.querySelector('#article-teasers .teaser-container')
            articleTeasers.innerHTML += response.teasers

            if (response.hasMoreArticles === false) {
               button.style.display = 'none'
            }
         },
         error => {
            console.log(error)
         }
      )
   })
}

// More Search Results Button

const btnMoreResults = document.getElementById('btn-more-results')

if (btnMoreResults) {
   const url = location.search.length ? location.search + '&' : '?'

   initLoadMoreBtn(btnMoreResults, url,
      response => {
         const resultList = document.getElementById('search-result-list')
         resultList.innerHTML += response.results

         initNew3QVideos()

         if (response.hasMoreResults === false) {
            btnMoreResults.style.display = 'none'
         }
      },
      error => {
         console.log(error)
      }
   )
}

// Appointment info action

if(document.getElementById('modalAppointment')) {
   const appointmentModal = new Modal(document.getElementById('modalAppointment'))
   const appointmentModalBody = document.getElementById('modalAppointmentBody')

   function addAppointmentClick() {
      const appointment = document.querySelectorAll('.appointment-list__row')
      
      appointment.forEach(function (appointment) {
         appointment.addEventListener('click', () => {
            const appointmentId = appointment.dataset.appointment
         
            fetch('/termine-events/' + appointmentId + '/', {
               headers: {
                  'X-Requested-With': 'XMLHttpRequest'
               }
            })
            .then(response => {
               if (response.status >= 200 && response.status < 400) {
                  return response.json()
               }
         
               return response.json()
                  .then(json => Promise.reject(json))
            })
            .then(response => {
               appointmentModalBody.innerHTML = response.content
               initSwiperInstances()
               initNew3QVideos()
               initMasonryDownload()
               initCountUp()

               appointmentModal.show()
            })
            .catch(error => {
               console.log(error)
            })
            .finally(() => {
            })
         })
      })                   
   }

   addAppointmentClick()

   appointmentModal._element.addEventListener('hidden.bs.modal', () => {
      appointmentModalBody.innerHTML = ''
   })

   const btnMoreAppointments = document.getElementById('btn-more-appointments')

   if (btnMoreAppointments) {
      const url = location.search.length ? location.search + '&' : '?'

      initLoadMoreBtn(btnMoreAppointments, url,
         response => {
            const appointmentListBody = document.querySelector('#appointment-list .appointment-list__body')
            appointmentListBody.innerHTML += response.appointments

            addAppointmentClick()

            if (response.hasMoreAppointments === false) {
               btnMoreAppointments.style.display = 'none'
            }
         },
         error => {
            console.log(error)
         }
      )
   }
}
if (typeof jQuery !== 'undefined') {
   jQuery(function() {
      if($('#Inputfield_projektstart_datum_limited').length) {
         var today = new Date();
         var lastYear = new Date();
         lastYear.setFullYear(today.getFullYear() - 1);
         $("#Inputfield_projektstart_datum_limited").datepicker({
            maxDate: lastYear,
            changeMonth: true,
            changeYear: true,
            dateFormat: 'dd.mm.yy'
         });
      }
   });
}

//YT Video 2-Click Solution */
const ytWrapper = document.querySelectorAll('.yt-wrapper');

if(ytWrapper.length) {
   ytWrapper.forEach(function(wrapper) {
      const trigger = wrapper.querySelector('.yt-wrapper_trigger');
      const iframe = wrapper.querySelector('.yt-wrapper_iframe');
      const btn = wrapper.querySelector('.yt-wrapper_btn');

      btn.addEventListener('click', function() {
         iframe.querySelector('iframe').setAttribute('src', trigger.dataset.src);
      
         trigger.style.display = 'none';
         iframe.style.display = 'block';
      });
   });
}
